//-----------------------------------
// productNotification.js
// Pops up when product added to cart
//-----------------------------------

import $ from 'jquery'



// sisterSize 
// ---------------------------------------
export let sistersize = {

	init() {
		$('.NewSizeChart-sisters--sorry, .NewSizeChart-sistersWrap, .NewSizeChart-sisters, .NewSizeChart-sisters--single').hide();
document.onkeydown = function(evt) {
evt = evt || window.event;
let isEscape = false;
if ("key" in evt) {
isEscape = evt.key == "Enter";
} else {
isEscape = evt.keyCode == 13;
}
if (isEscape) {
$('.NewSizeChart-btnSister').click();
}
};
		$('.NewSizeChart-btnSister').on('click', function(){
			// $(document).scrollTop(0);
			let newCupIndex = null;
			let newCupIndex2 = null;
			let currentSize = $('.NewSizeChart-sisterSize').val().toLowerCase();
			let currentBand = currentSize.slice(0, 2);
			let currentCup = currentSize.slice(2, 6);
			let allCups = ['aa', 'a', 'b', 'c', 'd', 'dd', 'ddd', 'g' ];
			// if user enters in e, change it to ddd. 
			if( currentCup == 'e' ){
				currentCup = 'dd';
			}else if( currentCup == 'f' ){
				currentCup = 'ddd';
			}
			// let weDontCarry = [ '32a', '30a', '40aa', '36f', '30aa', '32aa' ]; 
			// alert('currentCup "' + currentCup+'"');
			// alert('indexOf ' + allCups.indexOf(currentCup));
			// if your band size is too tight, go down in band, up in cup
				newCupIndex = allCups.indexOf(currentCup) - 1;
				let newBand = parseInt(currentBand) + 2;
			// if your cup is too small, go up in cup, down in band
				newCupIndex2 = allCups.indexOf(currentCup) + 1;
				let newBand2 = parseInt(currentBand) - 2;
			function bothSisters(){
				$('.NewSizeChart-band').text(newBand+allCups[newCupIndex]); 
				$('.NewSizeChart-cup').text(newBand2+allCups[newCupIndex2]);
				$('.NewSizeChart-sisters--sorry, .NewSizeChart-sisters--single').hide();
				$('.NewSizeChart-sistersWrap, .NewSizeChart-sisters').show();
			}
			function sisterCup(){
				$('.NewSizeChart-single').text(newBand+allCups[newCupIndex]); 
				$('.NewSizeChart-sistersWrap ,.NewSizeChart-sisters--single').show();
				$('.NewSizeChart-sisters, .NewSizeChart-sisters--sorry').hide();
			}
			function sisterBand(){
				$('.NewSizeChart-single').text(newBand2+allCups[newCupIndex2]); 
				$('.NewSizeChart-sistersWrap ,.NewSizeChart-sisters--single').show();
				$('.NewSizeChart-sisters, .NewSizeChart-sisters--sorry').hide();
			}

			

			//  if we can't find your size in the array of all cups, we dont carry it. we do find your size in the we dont carry list, we dont carry it
			if ( allCups.indexOf(currentCup) == -1 || currentBand % 2 != 0  ){
				// alert('we dont carry that size');
				sistersize.noCarry();
				console.log('no carry1');
				return;
			// if you're one of our edgecases, or your band is over 40, or under 30, we don't carry your sizd
			}else if( currentSize == '30aa' || currentSize == '32aa'|| currentSize == '32a' || currentSize == '30a' || currentSize == '40aa' || currentSize == '36f' || currentBand < 30  || currentBand > 41  ){
				sistersize.noCarry();
				console.log('no carry2');
				return;

			}else{
				
				// If your band is in the 30s, we only show you band. not cup size
				if( currentBand == '30' && currentCup != 'a' ){
					// 30s, only show going up in cup
					sisterCup();
					return;
				}else if( currentSize == '32dd'   ){
					//edge case
					sisterCup();
				// if your band is above 32 and you're an A cup
				}else if( currentBand > 32 && currentCup == 'a'  ){
					// 30s, only show going up in cup
					sisterBand();
					return;
				//  38 band edge cases
				}else if( currentBand == '38'  ){
					
					if( currentCup == 'aa' ){
						$('.NewSizeChart-single').text('36A'); 
						$('.NewSizeChart-sistersWrap ,.NewSizeChart-sisters--single').show();
						$('.NewSizeChart-sisters, .NewSizeChart-sisters--sorry').hide();
					// if your're a b-dd, we carry your size 
					}else if ( currentCup == 'b' || currentCup == 'c' || currentCup == 'd' || currentCup == 'dd'|| currentCup == 'ddd' || currentCup == 'g'  ){
						sisterBand();
					}else{
						console.log('no carry3');
						sistersize.noCarry();
						return;
					}
				// if hyour band is a 40, you can go down in band / up in cup. 
				}else if( currentBand == '40' || currentSize == '36b'  ){
					if ( currentCup == 'a' || currentCup == 'b' || currentCup == 'c' || currentCup == 'd'  || currentCup == 'dd' ){
						sisterBand();
					}else{
						console.log('no carry4');
						sistersize.noCarry();
						return;
					}
				// if you're a tripel d/e or an F, go up in band, down in cup. 
				}else if( currentCup == 'ddd' || currentCup == 'f'  ){
						sisterCup();
				}else if( currentCup == 'aa' && currentBand > 32  ){
					sisterBand();	
				}else{
					bothSisters();
				}
				

			}

		});

	}, 
	noCarry(){
		// alert('we dont carry that size');
		$('.NewSizeChart-sistersWrap ,.NewSizeChart-sisters--sorry').show();
		$('.NewSizeChart-sisters, .NewSizeChart-sisters--single').hide();
	}


	}


